import { render, staticRenderFns } from "./DictDataManage.vue?vue&type=template&id=bcd3c7a0&scoped=true&"
import script from "./DictDataManage.vue?vue&type=script&lang=js&"
export * from "./DictDataManage.vue?vue&type=script&lang=js&"
import style0 from "./DictDataManage.vue?vue&type=style&index=0&id=bcd3c7a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd3c7a0",
  null
  
)

export default component.exports